import styled from "@emotion/styled";
import * as React from "react";

interface HeaderProps {
  title: string;
  subtitle?: string;
  logo?: React.ReactNode;
  language?: React.ReactNode;
}

export function Header({ title, subtitle, logo, language }: HeaderProps) {
  return (
    <Container>
      {logo}
      <TextColumn>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </TextColumn>
      {language && <LanguageColumn>{language}</LanguageColumn>}
    </Container>
  );
}

const Container = styled.header`
  align-items: center;
  background: ${(props) => props.theme.colors.white};
  display: flex;
  gap: 12px;
  height: 72px;
  padding-left: 16px;
  padding-right: 16px;
  width: 100%;

  @media (min-width: 768px) {
    height: 88px;
    padding-left: 36px;
    padding-right: 36px;
  }
`;

const TextColumn = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h1`
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;

  @media (min-width: 768px) {
    font-size: 16px;
    text-align: left;
  }
`;

const Subtitle = styled.h2`
  color: ${(props) => props.theme.colors.purple[60]};
  font-size: 12px;
  font-weight: 400;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const LanguageColumn = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
  }
`;
